module.exports = __webpack_public_path__ + "browser-3_decol_o.9300653437b0e77f0755e06520aea526.svg";